module.exports = __webpack_public_path__ + "static/media/janio_big_logo.03d04770.svg";